import { render } from "./FacetPanelTree.vue?vue&type=template&id=5796bbea&scoped=true&ts=true"
import script from "./FacetPanelTree.vue?vue&type=script&lang=ts"
export * from "./FacetPanelTree.vue?vue&type=script&lang=ts"

import "./FacetPanelTree.vue?vue&type=style&index=0&id=5796bbea&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5796bbea"]])

export default __exports__